export const faqs = [
  {
    question: "Koliko košta instalacija sistema video nadzora?",
    answer: "Cena instalacije zavisi od broja kamera, tipa objekta i složenosti instalacije. Za standardnu kuću sa 4 kamere, cena instalacije se kreće od 200€ do 400€. Za poslovne objekte, radimo besplatnu procenu na licu mesta i dajemo precizan predračun bez obaveza.",
  },
  {
    question: "Da li kamere rade noću?",
    answer: "Da, sve naše IP kamere imaju ugrađen infracrveni (IR) LED sistem za noćni vid. U zavisnosti od modela, domet noćnog vida je od 30m do 60m. Premium modeli poseduju i noćni vid u boji (ColorVu tehnologija) koji daje kristalno jasnu sliku i u potpunom mraku.",
  },
  {
    question: "Mogu li da pratim kamere preko telefona?",
    answer: "Apsolutno. Sve naše kamere i sistemi dolaze sa besplatnom mobilnom aplikacijom za iOS i Android. Možete pratiti live stream, pregledati snimke, dobijati push notifikacije pri detekciji pokreta i upravljati sistemom sa bilo kog mesta na svetu gde imate internet konekciju.",
  },
  {
    question: "Šta se dešava sa snimcima? Gde se čuvaju?",
    answer: "Snimci se mogu čuvati na tri načina: lokalno na NVR rekorderu (hard disk), na microSD kartici u kameri, ili u cloudu. Preporučujemo NVR rekorder kao primarni način čuvanja jer omogućava neprekidno snimanje 24/7 sa kapacitetom do 30 dana arhive. Cloud opcija služi kao dodatna sigurnosna kopija.",
  },
  {
    question: "Kolika je garancija na opremu?",
    answer: "Sva oprema dolazi sa standardnom garancijom od 3 godine. Garancija pokriva sve fabričke defekte i kvarove. Dodatno, nudimo produženu garanciju od 5 godina uz godišnji ugovor o održavanju koji uključuje redovne servisne preglede i preventivno održavanje.",
  },
  {
    question: "Da li je moguće integrisati postojeći sistem sa novom opremom?",
    answer: "Da, u većini slučajeva možemo integrisati novu opremu sa postojećim sistemom. Naši inženjeri će na licu mesta proceniti kompatibilnost i predložiti optimalno rešenje. Podržavamo ONVIF standard što omogućava integraciju sa opremom različitih proizvođača.",
  },
  {
    question: "Kako funkcioniše video interfon sa aplikacijom?",
    answer: "Video interfon se povezuje na vašu WiFi mrežu i komunicira sa mobilnom aplikacijom. Kada neko pozvoni, dobijate video poziv na telefon — možete videti, razgovarati i otključati vrata sa bilo kog mesta. Sistem podržava do 8 spoljnih jedinica i 4 unutrašnja monitora.",
  },
  {
    question: "Da li nudite monitoring 24/7?",
    answer: "Da, posedujemo sopstveni monitoring centar koji radi 24/7. Naš tim prati alarmne signale, verifikuje video potvrdu i odmah reaguje po definisanim procedurama — od poziva vlasniku do obaveštavanja službi obezbeđenja. Cena monitoringa je od 2,500 RSD mesečno.",
  },
];